<template>
  <section class="card">
    <h2 class="section-heading">
      {{ t('employerForm.declarations.title') }}
    </h2>

    <div class="checkbox-group">
      <div class="checkbox-block">
        <label :class="['checkbox-item',{ 'is-invalid': formErrors.has('declarations.policyholderDeclarationAccepted') }]">
          <input type="checkbox" v-model="form.policyholderDeclarationAccepted"
            @change="clearError('declarations.policyholderDeclarationAccepted')" 
          />
          <span>
            1.
          </span>
          <span class="policy-text" v-html="t('employerForm.declarations.policyholderDeclarationAccepted')"></span>
        </label>
        <p class="invalid-feedback" v-if="formErrors.has('declarations.policyholderDeclarationAccepted')">
          {{ t(formErrors.first('declarations.policyholderDeclarationAccepted')) }}
        </p>
      </div>
      <div class="checkbox-block">
        <label :class="['checkbox-item',{ 'is-invalid': formErrors.has('declarations.candidateDeclarationAccepted') }]">
          <input type="checkbox" v-model="form.candidateDeclarationAccepted"
            @change="clearError('declarations.candidateDeclarationAccepted')" 
            
            />
          <span>
            2.
          </span>
          <span class="policy-text" v-html="t('employerForm.declarations.candidateDeclarationAccepted')"></span>
        </label>

        <p class="invalid-feedback" v-if="formErrors.has('declarations.candidateDeclarationAccepted')">
          {{ t(formErrors.first('declarations.candidateDeclarationAccepted')) }}
        </p>
      </div>

      <div class="checkbox-block">
        <label :class="['checkbox-item',{ 'is-invalid': formErrors.has('declarations.beneficiariesConsentAccepted') }]">
          <input type="checkbox" v-model="form.beneficiariesConsentAccepted"
            @change="clearError('declarations.beneficiariesConsentAccepted')"   
          />
          <span>
            3.
          </span>
          <span class="policy-text" v-html="t('employerForm.declarations.beneficiariesConsentAccepted')"></span>
        </label>

        <p class="invalid-feedback" v-if="formErrors.has('declarations.beneficiariesConsentAccepted')">
          {{ t(formErrors.first('declarations.beneficiariesConsentAccepted')) }}
        </p>
      </div>

      <div class="checkbox-block">
        <label :class="['checkbox-item',{ 'is-invalid': formErrors.has('declarations.agentAuthorizationAccepted') }]">
          <input type="checkbox" v-model="form.agentAuthorizationAccepted"
            @change="clearError('declarations.agentAuthorizationAccepted')" 
          />
          <span>
            4.
          </span>
          <span class="policy-text" v-html="t('employerForm.declarations.agentAuthorizationAccepted')">
          </span>
        </label>

        <p class="invalid-feedback" v-if="formErrors.has('declarations.agentAuthorizationAccepted')">
          {{ t(formErrors.first('declarations.agentAuthorizationAccepted')) }}
        </p>
      </div>

      <div class="checkbox-block">
        <label :class="['checkbox-item',{ 'is-invalid': formErrors.has('declarations.materialInformationAccepted') }]">
          <input type="checkbox" v-model="form.materialInformationAccepted"
            @change="clearError('declarations.materialInformationAccepted')" 
          />
          <span>
            5.
          </span>
          <span class="policy-text" v-html="t('employerForm.declarations.materialInformationAccepted')">
          </span>
        </label>

        <p class="invalid-feedback" v-if="formErrors.has('declarations.materialInformationAccepted')">
          {{ t(formErrors.first('declarations.materialInformationAccepted')) }}
        </p>
      </div>
      <div class="checkbox-block">
        <div>
          <span>
            6.
          </span>
          <span class="policy-text" v-html="t('employerForm.declarations.digitalCommunicationAccepted')"></span>
        </div>

        <div :class="['radio-group','mt-3',{ 'is-invalid': formErrors.has('declarations.digitalCommunicationAccepted') }]">
          <label class="radio-item">
            <input type="radio" :value="true" v-model="form.digitalCommunicationAccepted"
              @change="clearError('declarations.digitalCommunicationAccepted')" 
            />
            <span>{{ t('common.yes') }}</span>
          </label>

          <label class="radio-item">
            <input type="radio" :value="false" v-model="form.digitalCommunicationAccepted"
              @change="clearError('declarations.digitalCommunicationAccepted')" 
            />
            <span>{{ t('common.no') }}</span>
          </label>
        </div>

        <p class="invalid-feedback" v-if="formErrors.has('declarations.digitalCommunicationAccepted')">
          {{ t(formErrors.first('declarations.digitalCommunicationAccepted')) }}
        </p>
      </div>
      <div class="checkbox-block">
        <label :class="['checkbox-item',{ 'is-invalid': formErrors.has('declarations.privacyPolicyAccepted') }]">
          <input type="checkbox" v-model="form.privacyPolicyAccepted"
            @change="clearError('declarations.privacyPolicyAccepted')" 
          />
          <span>
            7.
          </span>
          <span class="policy-text" v-html="t('employerForm.declarations.privacyPolicyAccepted')">
          </span>
        </label>

        <p class="invalid-feedback" v-if="formErrors.has('declarations.privacyPolicyAccepted')">
          {{ t(formErrors.first('declarations.privacyPolicyAccepted')) }}
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import Error from '@/utils/Error';
import { reactive, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({})
  },

  formErrors: {
    type: Object,
    required: false,
    default: reactive(new Error({}))
  }
});

const emit = defineEmits([
  'update:modelValue',
  'removeError'
]);

const form = reactive({
  policyholderDeclarationAccepted: false,
  candidateDeclarationAccepted: false,
  beneficiariesConsentAccepted: false,
  agentAuthorizationAccepted: false,
  materialInformationAccepted: false,
  digitalCommunicationAccepted:false,
  privacyPolicyAccepted:false,
  ...props.modelValue
});

watch(
  form,
  (val) => emit('update:modelValue', val),
  { deep: true }
);

watch(
  () => props.modelValue,
  (newValue) => {
    Object.assign(form, {
      policyholderDeclarationAccepted: false,
      candidateDeclarationAccepted: false,
      beneficiariesConsentAccepted: false,
      agentAuthorizationAccepted: false,
      materialInformationAccepted: false,
      ...newValue
    });
  },
  { deep: true, immediate: true }
);

const clearError = (name) => {
  emit('removeError', name);
};
</script>

<style scoped>
.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.checkbox-block {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  padding: 10px 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
}

.checkbox-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  line-height: 1.5;
}

.policy-text {
  white-space: pre-line;
}
.checkbox-item input[type="checkbox"], .radio-item input[type="radio"] {
  width: 20px;
  height: 20px;
  min-width: 20px;
  margin-top: 2px; 
  cursor: pointer;
}
.radio-group {
  display: flex;
  gap: 12px;
}

.radio-item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
</style>